'use client';

import { useEffect, useState } from 'react';
import { Configure, Index } from 'react-instantsearch';
import isNil from 'lodash-es/isNil';
import { BuyerListingFavorite } from '@/legacy/favorites/FavoritesViewModel';
import { WishlistsWithMetadata } from '../../wishlist/types';
import { ListingCardsSkeleton } from '../ListingCardsSkeleton';
import { FlatBuyerPreferences, ListingHomePageRecommendation } from '../types';
import { Content } from './Content';

type Props = {
  categoriesPromise: Promise<{ [key: string]: string[] }>;
  favoritesPromise: Promise<BuyerListingFavorite[]>;
  listingHomePageRecommendationsPromise: Promise<ListingHomePageRecommendation[]>;
  listingsIndexName: string;
  preferencesPromise: Promise<FlatBuyerPreferences>;
  wishlistsPromise: Promise<WishlistsWithMetadata>;
  isStockXSectionEnabled: boolean;
};

export const AlgoliaIndexWrapper = ({
  categoriesPromise,
  favoritesPromise,
  listingHomePageRecommendationsPromise,
  listingsIndexName,
  preferencesPromise,
  wishlistsPromise,
  isStockXSectionEnabled,
}: Props) => {
  // Using 'use' to get the data was causing hydration issues. Resolving the promise
  // in a useEffect hook is a workaround.
  const [listingHomePageRecommendations, setListingHomePageRecommendations] = useState<
    ListingHomePageRecommendation[] | null
  >(null);

  useEffect(() => {
    listingHomePageRecommendationsPromise.then(setListingHomePageRecommendations);
  }, [listingHomePageRecommendationsPromise]);

  // If the promise is still pending, show a skeleton
  if (isNil(listingHomePageRecommendations)) {
    return <ListingCardsSkeleton hitsPerPage={8} />;
  }

  const filters = listingHomePageRecommendations.map((l) => `objectID:${l.listingId}`).join(' OR ');

  return (
    <Index indexName={listingsIndexName} indexId="handpicked-for-you">
      <Configure hitsPerPage={listingHomePageRecommendations.length} filters={filters} />
      <Content
        categoriesPromise={categoriesPromise}
        favoritesPromise={favoritesPromise}
        listingHomePageRecommendations={listingHomePageRecommendations}
        preferencesPromise={preferencesPromise}
        wishlistsPromise={wishlistsPromise}
        isStockXSectionEnabled={isStockXSectionEnabled}
      />
    </Index>
  );
};
